import React from "react";
import Image from "../../../../components/Image";
import { Container, ImageWrapper } from "./styles";

type Props = {
  name:
    | "globe"
    | "factory"
    | "book"
    | "templateComment"
    | "computer"
    | "docNotIncluded"
    | "graphs"
    | "info"
    | "money"
    | "noBook"
    | "noMoney"
    | "users"
    | "writingPad";
  size?: number;
};

const SubIcon: React.FC<Props> = ({ name, size = 40 }) => {
  return (
    <Container>
      <ImageWrapper>
        <Image name={name} height={size} width={size} />
      </ImageWrapper>
    </Container>
  );
};

export default SubIcon;
